var map = {
	"./algorithms.svg": "f454",
	"./caret-down.svg": "dc4a",
	"./chart.svg": "3653",
	"./dashboard.svg": "6f9f",
	"./data-privacy.svg": "5dd7",
	"./filter.svg": "bcee",
	"./fullscreen-exit.svg": "db31",
	"./fullscreen.svg": "cc7c",
	"./goal.svg": "29e9",
	"./group.svg": "df55",
	"./helper.svg": "c90e",
	"./individual.svg": "7d6a",
	"./nodes.svg": "2eee",
	"./password-policy.svg": "8e4c",
	"./permission.svg": "1cc0",
	"./reminder.svg": "9cdf",
	"./report.svg": "bbee",
	"./security.svg": "fde2",
	"./setting.svg": "614f",
	"./share.svg": "940a",
	"./time.svg": "6fc1",
	"./upgrade.svg": "de49",
	"./user.svg": "4d66",
	"./vitals.svg": "2e82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";